<template>
    <div class="lycontainer">
        <el-scrollbar>
            <div>
                <ly-growcard :loading="showloading" :rows="2" v-model="growData"></ly-growcard>
            </div>
            <div class="echarts-inner">
                <ly-echartcard :loading="showloading" :rows="3" v-model="growData"></ly-echartcard>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
    import LyGrowcard from "@/components/analysis/growCard";
    import LyEchartcard from "@/components/analysis/echartCard";
	import {systemDashSale,systemDashTotalSale} from '@/api/api'
	import {FormatMoney} from "@/utils/util";
    export default {
        name: "analysis",
        components: {LyEchartcard, LyGrowcard},
        data(){
            return{
			
                showloading:true,
                growData:[
                    {id:1,title:"结单量（笔）",nums:'',totalnums:'',icon:{
                            type:"Sell",
                            background:"#67c23a",
                        },
                        time:{
                            name:"日/年",
                            type:"success"
                        }},
                    {id:2,title:"结算金额（元）",nums:'',totalnums:'',icon:{
                            type:"Coin",
                            background:"#e6a23c",
                        },
                        time:{
                            name:"日/年",
                            type:"warning"
                        }},
                    {id:3,title:"收益金额（元）",nums:'',totalnums:'',icon:{
                            type:"Medal",
                            background:"#409eff",
                        },
                        time:{
                            name:"日/年",
                            type:""
                        }},
                    {id:4,title:"其他支出（元）",nums:'',totalnums:'',icon:{
                            type:"WalletFilled",
                            background:"#f56c6c",
                        },
                        time:{
                            name:"日/年",
                            type:"danger"
                        }},
                ],
                echartsData:[

                ],
            }
        },
        methods:{
            setFull(){
                window.dispatchEvent(new Event('resize'))
            },
			 getData() {
			 
			    systemDashSale().then(res => {
			        
			        if(res.code ==2000) {
					  //订单量
					   this.growData[0].nums=res.data[1].saleTotal
					   this.growData[0].totalnums=res.data[0].saleTotal
					   
					   //销售额
					   this.growData[1].nums=FormatMoney(res.data[1].salesAmount)
					   this.growData[1].totalnums=FormatMoney(res.data[0].salesAmount)
					  //支付额
					  this.growData[2].nums=FormatMoney(res.data[1].totalPay)
					  this.growData[2].totalnums=FormatMoney(res.data[0].totalPay)
					  
					  //其他支付
					  this.growData[3].nums=FormatMoney(res.data[1].otherPay)
					  this.growData[3].totalnums=FormatMoney(res.data[0].otherPay)
			        }
			    })
			},
			
			totalSale(){
				systemDashTotalSale().then(res => {
				        
				        if(res.code ==2000) {
							
							let saleAmtArr=[]
							 res.data.forEach(function(data) {
								 saleAmtArr.push(data.salesAmount/100);
								  
								 })
								  console.log(saleAmtArr)
						 localStorage.setItem('saleAmtArr', saleAmtArr)
				        }
				    })
			},
        },
        created() {
			this.totalSale()
			this.getData()
            setTimeout(() => {
                this.showloading = false
            }, 600)
        },
    }
</script>
<style lang="scss" scoped>
    .lycontainer{
        /*width: 100%;*/
        height: calc(100vh - 113px); //动态计算长度值
        /*overflow-x: hidden;*/
        /*overflow-y:auto;*/
    }
    .echarts-inner{
        margin-top: 1px;
    }
    ::v-deep(.el-scrollbar__bar.is-horizontal) {
        display: none;
    }
    .echartsMaps{
        margin-top: 10px;
        /*margin-bottom: 40px;*/
        :deep(.is-hover-shadow){
            margin-bottom: 10px;
        }
        :deep(.is-never-shadow){
            margin-bottom: 10px;
        }
    }
</style>